import { Stack } from "@mui/material";
import { Link } from "react-router-dom";

import { logo } from "../utils/constants";
import { SearchBar } from "./";
import Switch from "./Switch";

const Navbar = ({ color, setColor }) => (
  <Stack
    direction="row"
    alignItems="center"
    p={2}
    sx={{
      height: 30,
      position: "sticky",
      background: color ? "#dadada" : "#121212",
      top: 0,
      justifyContent: "space-between",
    }}
  >
    <Link to="/" style={{ display: "flex", alignItems: "center" }}>
      <h5 style={{ color: color ? "#121212" : "#dadada" }}>Videos Tube</h5>
    </Link>
    <span>
      <div style={{ position: "absolute", left: 120, top: 15 }}>
        <Switch
          isOn={color}
          onColor="#f4e04d"
          onOff="#587792"
          handleToggle={() => setColor(!color)}
        />
      </div>
    </span>

    <SearchBar />
  </Stack>
);

export default Navbar;
